import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Volume2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VoiceButton = ({ voice, text, label, testId }) => {
  const [state, setState] = useState("idle");
  const audioRef = useRef(null);

  const stop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    setState("idle");
  };

  const play = async () => {
    if (state === "loading") return;
    if (state === "playing") return stop();
    setState("loading");
    try {
      const { data } = await axios.post(`${API}/voice/speak`, { text, voice });
      const audio = new Audio(data.audio_url);
      audioRef.current = audio;
      audio.onended = () => setState("idle");
      setState("playing");
      await audio.play();
    } catch (e) {
      toast.error("La voix est momentanément indisponible.");
      setState("idle");
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={play}
      className={`group inline-flex items-center gap-2.5 rounded-full border px-5 py-2.5 text-sm transition-all duration-300 hover:-translate-y-0.5 ${
        state === "playing"
          ? "border-viol/60 bg-viol/20 text-white"
          : "border-viol/35 bg-viol/10 text-viol-pale hover:bg-viol/20 hover:border-viol/60"
      }`}
    >
      {state === "loading" ? (
        <Loader2 size={16} className="animate-spin" />
      ) : state === "playing" ? (
        <span className="flex h-4 items-end gap-0.5" aria-hidden="true">
          {[0.6, 1, 0.75].map((h, i) => (
            <span
              key={i}
              className="w-1 origin-bottom rounded-full bg-viol-pale animate-wave"
              style={{ height: `${h * 100}%`, animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </span>
      ) : (
        <Volume2 size={16} />
      )}
      {label}
    </button>
  );
};

export default VoiceButton;
